

import React, { useState } from 'react';

function ListaProfesores() {
  
  const [profesores] = useState([
    { nombre: 'Erika órdenes Villaroel', cargo: 'Profesor(a) Jefe de: Pre-Kinder', correo: 'eordenes@nzelandia.cl', ciclo: 1 },
    { nombre: 'Leslie Cristi Olavarría', cargo: 'Técnico en Párvulos Pre-kinder', correo: 'lcristi@nzelandia.cl', ciclo: 1 },

    { nombre: 'Millaray Ramirez Mardones', cargo: 'Profesor(a) Jefe de: kinder', correo: 'Mramirez@nzelandia.cl', ciclo: 1 },
    { nombre: 'Valeria Diaz Reyes', cargo: 'Técnico en Párvulos kinder', correo: 'vdiaz@nzelandia.cl', ciclo: 1 },
    
    { nombre: 'Alén Munay Briceño', cargo: 'Profesor(a) Jefe de: 1° básico', correo: 'abriceno@nzelandia.cl', ciclo: 1 },
    { nombre: 'Isaac Jiménez', cargo: 'Profesor(a) Jefe de: 2° básico', correo: 'ijimenez@nzelandia.cl', ciclo: 1 },
    { nombre: 'Pamela Andrea Jorquera', cargo: 'Profesor(a) Jefe de: 3° básico', correo: 'pjorquera@nzelandia.cl', ciclo: 1 },
    { nombre: 'Karin Alejandra Vergara Muñoz', cargo: 'Profesor(a) Jefe de: 4° básico', correo: 'kvergara@nzelandia.cl', ciclo: 1 },
    { nombre: 'Luis Alberto Morales', cargo: 'Profesor(a) Jefe de: 5° básico', correo: 'lmorales@nzelandia.cl', ciclo: 2 },
    { nombre: 'Cristina Catalina Marín', cargo: 'Profesor(a) Jefe de: 6° básico', correo: 'cmarin@nzelandia.cl', ciclo: 2 },
    { nombre: 'Nicolás Jiménez', cargo: 'Profesor(a) Jefe de: 7° básico', correo: 'njimenez@nzelandia.cl', ciclo: 2 },
    { nombre: 'Claudia Andrea Guerra', cargo: 'Profesor(a) Jefe de: 8° básico', correo: 'cguerra@nzelandia.cl', ciclo: 2 },
    { nombre: 'Karina Dalia Echeverria', cargo: 'Profesor(a) Coordinador(a)', correo: 'kecheverria@nzelandia.cl', ciclo: 'Centro de Innovación' },
    { nombre: 'Giovanni Mauricio Neira Valencia', cargo: 'Encargado Centro de Innovación', correo: 'gneira@nzelandia.cl', ciclo: 'Centro de Innovación' },
    { nombre: 'Claudia Alejandra Aracena', cargo: 'Profesor(a) Coordinador(a) CRA', correo: 'caracena@nzelandia.cl', ciclo: 'CRA' },
    { nombre: 'Alejandra Flores Retamales', cargo: 'Encargada Cra y Salud Escolar', correo: 'axflores@nzelandia.cl', ciclo: 'CRA' },
    { nombre: 'Katherina Paz Cifuentes', cargo: 'Coordinadora P.I.E.', correo: 'kcifuentes@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Andrea Soledad Zirpel', cargo: 'Fonoaudióloga', correo: 'azirpel@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Camila Pérez', cargo: 'Fonoaudióloga', correo: 'cperez@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Yérica Guerrero', cargo: 'Psicóloga P.I.E.', correo: 'yguerrero@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Julio Dominguez', cargo: 'Terapeuta Ocupacional P.I.E.', correo: 'jdominguez@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Susana Rita Sasso', cargo: 'Docente P.I.E.', correo: 'ssasso@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Pamela Denisse Vidal', cargo: 'Docente P.I.E.', correo: 'pvidal@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Maria José Astorga', cargo: 'Docente P.I.E.', correo: 'mastorga@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Cecilia Ethel Sánchez Vachy', cargo: 'Docente P.I.E.', correo: 'csanchez@nzelandia.cl', ciclo: 'Equipo P.I.E.' },
    { nombre: 'Marcia Silva Donoso', cargo: 'Secretaría de Dirección', correo: 'msilva@nzelandia.cl', ciclo: 'Administrativo' },
    { nombre: 'María Alveal Carrasco', cargo: 'Administrativa/Encargada PAE', correo: 'malveal@nzelandia.cl', ciclo: 'Administrativo' },
    { nombre: 'Leslie Cristi Olavarría', cargo: 'Técnico en Párvulos', correo: 'lcristi@nzelandia.cl', ciclo: 'Asistentes' },
    
    { nombre: 'Valeria Diaz Reyes', cargo: 'Técnico en Párvulos', correo: 'vdiaz@nzelandia.cl', ciclo: 'Asistentes' },

    { nombre: 'Alejandra Flores Retamales', cargo: 'Encargada Cra y Salud Escolar', correo: 'axflores@nzelandia.cl', ciclo: 'Asistentes' },
    { nombre: 'Giovanni Neira Valencia', cargo: 'Encargado Centro de Innovación', correo: 'gneira@nzelandia.cl', ciclo: 'Asistentes' },
    { nombre: 'Andrea Soledad Zirpel', cargo: 'Fonoaudióloga', correo: 'azirpel@nzelandia.cl', ciclo: 'Asistentes' },
    { nombre: 'María Eugenia Olavarría Mardones', cargo: 'Inspectora de Patio (Pre-Kínder a 2do)', correo: 'molavarria@nzelandia.cl', ciclo: 'Inspectoria' },
    { nombre: 'Sandra Massone Arancibia', cargo: 'Inspectora de Patio (3ro, 4to y 5to)', correo: 'smassone@nzelandia.cl', ciclo: 'Inspectoria' },
    { nombre: 'Jeannette Silva Manzo', cargo: 'Inspectora de Patio (6to, 7mo, 8vo)', correo: 'jsilva@nzelandia.cl', ciclo: 'Inspectoria' },
    { nombre: 'Nancy González Villalón', cargo: 'Auxiliar de Servicios Menores', correo: 'ngonzalez@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Berta Parra Baeza', cargo: 'Auxiliar de Servicios Menores', correo: 'bparra@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Yessenia Toro Pérez', cargo: 'Auxiliar de Servicios Menores', correo: 'ytoro@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Eliana Espinoza Orellana', cargo: 'Auxiliar de Servicios Menores', correo: 'eespinoza@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Paola Cornejo Taiba', cargo: 'Auxiliar de Servicios Menores', correo: 'pcornejo@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Antonina Ulloa Córdova', cargo: 'Auxiliar de Servicios Menores', correo: 'aulloa@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'María Flores Sanhueza', cargo: 'Auxiliar de Servicios Menores', correo: 'mflores@nzelandia.cl', ciclo: 'Auxiliar' },
    { nombre: 'Miguel García Arroyo', cargo: 'Nochero', correo: 'mgarcia@nzelandia.cl', ciclo: 'Asistentes' },
  ]);

  const [profesoresAsignatura] = useState([
    { nombre: 'Claudia Alejandra Aracena', cargo: 'Lenguaje', correo: 'caracena@nzelandia.cl', ciclo: 1 },
    { nombre: 'Claudia Andrea Guerra', cargo: 'Historia', correo: 'cguerra@nzelandia.cl', ciclo: 1 },
    { nombre: 'Yenny Andrea Arriagada', cargo: 'Inglés', correo: 'yarriagada@nzelandia.cl', ciclo: 2 },
    { nombre: 'Luis Alberto Morales', cargo: 'Educación Física', correo: 'lmorales@nzelandia.cl', ciclo: 2 },
    { nombre: 'Nicolás Andre Jiménez', cargo: 'Ciencias Naturales', correo: 'njimenez@nzelandia.cl', ciclo: 2 },
    { nombre: 'Cristina Catalina Marín', cargo: 'Matemáticas', correo: 'cmarin@nzelandia.cl', ciclo: 2 },
    { nombre: 'Gregory Wilfredo Arias', cargo: 'Música', correo: 'garias@nzelandia.cl', ciclo: 2 },
    { nombre: 'Sofía Martinez', cargo: 'Danza', correo: 'smartinez@nzelandia.cl', ciclo: 2 },
  ]);

  const obtenerProfesoresPorCiclo = (ciclo) => profesores.filter((p) => p.ciclo === ciclo);

  return (
    
    <div className="lista-profesores">
      <section id="ListaProfesores"></section>
      <h2 className="titulo-principal">Personal Establecimiento</h2>
      <div className="columnas">
        {['Administrativo','Asistentes','Inspectoria','Auxiliar',1,2,'Centro de Innovación','Equipo P.I.E.','CRA'].map((ciclo) => (
          <div key={ciclo} className="columna">
            <h3 className="titulo-columna">{typeof ciclo === 'string' ? ciclo : `Ciclo ${ciclo}`}</h3>
            <ul>
              {obtenerProfesoresPorCiclo(ciclo).map((profesor,index)=>(
                <li key={index} className="profesor-item">
                  <strong>Nombre:</strong> {profesor.nombre} <br />
                  {profesor.cargo} <br />
                  <strong>Correo:</strong> {profesor.correo}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* 🔹 Nueva tarjeta de Profesores de Asignaturas */}
        <div className="columna">
          <h3 className="titulo-columna">Profesores por Asignaturas</h3>
          <ul>
            {profesoresAsignatura.map((profesor, index) => (
              <li key={index} className="profesor-item">
                <strong>Nombre:</strong> {profesor.nombre} <br />
                <strong>Asignatura:</strong> {profesor.cargo} <br />
                <strong>Correo:</strong> {profesor.correo}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style jsx>{`
        .lista-profesores {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          text-align: center;
        }
        .titulo-principal {
          font-size: 28px;
          font-weight: bold;
          color: black;
          background: rgba(255, 255, 255, 0.7);
          display: inline-block;
          padding: 10px 25px;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.3);
          margin: 0 auto 20px;
        }
        .columnas {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
        }
        .columna {
          flex: 1 1 300px;
          padding: 20px;
          border-radius: 12px;
          background: rgba(3, 49, 140, 0.5);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          color: #fff;
          box-shadow: 0 4px 16px rgba(0,0,0,0.25);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .titulo-columna {
          text-align: center;
          margin-bottom: 15px;
          font-size: 20px;
          color: #ffffff;
        }
        .columna:hover {
          transform: scale(1.02);
          box-shadow: 0 6px 20px rgba(0,0,0,0.35);
        }
        .profesor-item {
          margin-bottom: 15px;
          text-align: center;
        }
        @media (max-width:768px){
          .columnas {flex-direction: column;}
        }
      `}</style>
    </div>
  );
}

export default ListaProfesores;
